import type { KeyboardEvent as ReactKeyboardEvent } from 'react';

/** Ditampilkan di atas filter daftar CRM — query Strapi. Dropdown (Select): langsung saat nilai berubah. Kolom teks: blur atau Enter. */
export const LIST_FILTERS_APPLY_HINT =
  'Filter memakai pencarian di server Strapi. Dropdown diterapkan langsung ketika Anda memilih opsi. Kolom teks diterapkan setelah Anda keluar dari field (blur) atau menekan Enter.';

/** `onKeyDown` untuk TextField filter — Enter sama seperti blur. */
export function commitListFiltersOnEnter(commit: () => void) {
  return (event: ReactKeyboardEvent) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      commit();
    }
  };
}
